<template>
  <div class="page_">
    <div>
      <a-form layout="inline" :form="form">
        <a-form-item label="发票抬头" style="margin-bottom:10px;">
          <a-input
            v-model="billTop"
            placeholder="支持模糊匹配"
            style="width:200px;"
          ></a-input>
        </a-form-item>
        <a-form-item label="发票号码">
          <a-input
            v-model="billNumber"
            placeholder="请输入发票号码"
            style="width:200px;"
          ></a-input>
        </a-form-item>
        <a-form-item label="发票代码">
          <a-input
            v-model="billCode"
            placeholder="请输入发票代码"
            style="width:200px;"
          ></a-input>
        </a-form-item>
        <a-form-item label="保单号码">
          <a-input
            v-model="policyNo"
            placeholder="请输入保单号"
            style="width:200px;"
          ></a-input>
        </a-form-item>
        <a-form-item label="发票申请日期">
          <a-range-picker
            @change="rangeDate"
            :showToday="false"
            :allowClear="false"
            v-model="timeValue"
            :placeholder="['请选择日期', '请选择日期']"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="searchData()">查询</a-button>
          <a-button style="margin-left: 8px;" type="primary" @click="goApply"
            >发票申请</a-button
          >
          <a-button style="margin-left: 8px;" type="default" @click="initData('reset')"
            >重置</a-button
          >
        </a-form-item>
      </a-form>
    </div>
    <a-table
      style="margin-top: 17px;"
      :scroll="{ x: 1500 }"
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      @change="handlePageChange"
      class="table_b"
    >
      <template slot="billLink" slot-scope="text, record">
        <a :href="record.billLink" target="_blank">下载</a>
      </template>
      <span slot="status" slot-scope="text, record">
        <span>{{ text | filterStatus(billStatusOptions) }}</span>
      </span>
      <span slot="billNumber" slot-scope="text, record">
        <a href="javascript:;" @click="queryPolicy(record)">{{ text }}</a>
      </span>
    </a-table>
    <a-table
      style="margin-top: 17px;table-layout:fixed"
      :columns="columns1"
      :scroll="{ x: 1500 }"
      :dataSource="tableData1"
      :pagination="false"
      class="table_b"
    >
      <span slot="status" slot-scope="text, record">
        <span>{{ text | filterStatus(policyStatusOptions) }}</span>
      </span>
    </a-table>
    <!-- <a-button type="primary" @click="downLoadInvoices()" style="margin:20px auto;display:block;">发票下载</a-button> -->
  </div>
</template>
<style lang="scss" scoped>
.table_b {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
<script>
import api from "@/utils/api";
import navbar from "../components/navbar";
const columns = [
  {
    title: "发票号码",
    key: "billNumber",
    dataIndex: "billNumber",
    scopedSlots: { customRender: "billNumber" },
  },
  {
    title: "发票代码",
    key: "billCode",
    dataIndex: "billCode",
  },
  {
    title: "发票状态",
    key: "status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "发票抬头",
    key: "billTop",
    dataIndex: "billTop",
  },
  {
    title: "税费",
    key: "taxDue",
    dataIndex: "taxDue",
  },
  {
    title: "发票金额",
    key: "total",
    dataIndex: "total",
  },
  {
    title: "纳税人识别号",
    key: "taxpayerCertificateNo",
    dataIndex: "taxpayerCertificateNo",
  },
  {
    title: "手机号",
    key: "billingPhone",
    dataIndex: "billingPhone",
  },
  {
    title: "邮箱",
    key: "billingEmail",
    dataIndex: "billingEmail",
  },
  {
    title: "开票申请日",
    key: "creatTime",
    dataIndex: "creatTime",
  },
  {
    title: "发票链接",
    key: "billLink",
    dataIndex: "billLink",
    scopedSlots: { customRender: "billLink" },
  },
];
const columns1 = [
  {
    title: "No",
    key: "id",
    dataIndex: "id",
  },
  {
    title: "发票号码",
    key: "billNumber",
    dataIndex: "billNumber",
  },
  {
    title: "发票代码",
    key: "billCode",
    dataIndex: "billCode",
  },
  {
    title: "保单号",
    key: "policyNo",
    dataIndex: "policyNo",
  },
  {
    title: "保单状态",
    key: "status",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "产品名称",
    key: "productName",
    dataIndex: "productName",
  },
  {
    title: "计划名称",
    key: "planName",
    dataIndex: "planName",
  },
  {
    title: "保费",
    key: "totalPremium",
    dataIndex: "totalPremium",
  },
  {
    title: "保险起期",
    key: "effectiveDate",
    dataIndex: "effectiveDate",
  },
  {
    title: "保险止期",
    key: "expireDate",
    dataIndex: "expireDate",
  },
];

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      columns1,
      tableData: [],
      tableData1: [],
      pagination: {
        total: 0,
        pageSize: 20,
        pageNum: 1,
      },
      billStatusOptions: [
        {
          value: "0",
          text: "初始",
        },
        {
          value: "1",
          text: "已开票",
        },
        {
          value: "2",
          text: "已红冲",
        },
      ],
      policyStatusOptions: [
        {
          value: "1",
          text: "已出单",
        },
        {
          value: "2",
          text: "已退保",
        },
      ],
      pageNum: "1",
      pageSize: "20",
      billTop: "",
      billNumber: "",
      billCode: "",
      policyNo: "",
      invoiceDateStart: "",
      invoiceDateEnd: "",
      timeValue: [],
      selectedRowKeys: [],
      queryBillsData: [], //初始发票查询参数
    };
  },
  filters: {
    filterStatus: (val, statusOptions) => {
      if (!val || val === "" || val === undefined) {
        return "";
      } else {
        let typeName = "";
        statusOptions.map((item) => {
          if (item.value == val) {
            typeName = item.text;
          }
        });
        return typeName;
      }
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    goApply() {
      window.open(
        "http://dicc.nanyanbx.com/ins-plus/billController/applyInvoice"
      ); //发票申请测试链接
    },
    handlePageChange(e) {
      this.pageNum = e.current;
      let queryData = {
        page: this.pageNum,
        rows: this.pageSize,
        billTop: this.billTop,
        billNumber: this.billNumber,
        billCode: this.billCode,
        policyNo: this.policyNo,
        invoiceDateStart: this.invoiceDateStart,
        invoiceDateEnd: this.invoiceDateEnd,
      };
      if (
        !this.billTop &&
        !this.billNumber &&
        !this.billCode &&
        !this.policyNo &&
        !this.timeValue[0]
      ) {
        this.initData();
      } else {
        this.queryData(queryData);
      }
    },
    onSelectChange(selectedRowKeys) {
      console.log(selectedRowKeys, "selectedRowKey---->");
      this.selectedRowKeys = selectedRowKeys;
    },
    rangeDate(dates, dateStrings) {
      this.createValue = dates;
      this.invoiceDateStart = dateStrings[0];
      this.invoiceDateEnd = dateStrings[1];
    },
    initData(reset) {
      if(reset){
        this.pageNum = 1
      }
      this.billTop = "";
      this.billNumber = "";
      this.billCode = "";
      this.policyNo = "";
      this.timeValue = [];
      this.tableData = [];
      this.findUserPolicy().then(() => {
        this.queryData({ invoiceQueryList: this.queryBillsData });
      });
    },
    queryData(queryData) {
      api.queryAllBills(queryData).then((res) => {
        if (res.data.policyBillList) {
          this.tableData = res.data.policyBillList.map((item, index) => {
            item.key = index;
            return item;
          });
          this.pagination.total = res.data.total;
        }
      });
    },
    findUserPolicy() {
      //根据保单号查询发票，后端要求
      let data = {
        pageNum: "1",
        pageSize: "1000",
        status: 1,
      };
      return api.findUserPolicy(data).then((res) => {
        this.queryBillsData = res.data.data.list.map((item) => {
          return {
            policyNo: item.policyNo,
            page: this.pageNum,
            rows: "10",
          };
        });
      });
    },
    searchData() {
      let queryData = {
        page: 1,
        rows: this.pageSize,
        billTop: this.billTop,
        billNumber: this.billNumber,
        billCode: this.billCode,
        policyNo: this.policyNo,
        invoiceDateStart: this.invoiceDateStart,
        invoiceDateEnd: this.invoiceDateEnd,
      };
      if (
        !this.billTop &&
        !this.billNumber &&
        !this.billCode &&
        !this.policyNo &&
        !this.timeValue[0]
      ) {
        this.initData();
      } else {
        this.queryData(queryData);
      }
    },
    queryPolicy(record) {
      console.log(record);
      api
        .queryBillPolicy({
          billNumber: record.billNumber,
          billCode: record.billCode,
        })
        .then((res) => {
          if (res.data.returnCode === "00") {
            this.tableData1 = res.data.policyInfos.map((item, index) => {
              return {
                billNumber: record.billNumber,
                billCode: record.billCode,
                ...item.policyInfo,
              };
            });
          } else {
            this.$message.error(res.data.returnMsg);
          }
        });
    },
  },
};
</script>
